module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "C153"
  }, [_c('a', {
    attrs: {
      "id": "page_vii"
    }
  }, [_vm._v("Contents")])]), _c('a', {
    attrs: {
      "id": "page_vii"
    }
  }), _c('p', {
    staticClass: "C180"
  }, [_c('a', {
    attrs: {
      "id": "page_vii"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/06_Interviews#page_ix"
    }
  }, [_vm._v("Interviews")])]), _vm._v(" "), _c('p', {
    staticClass: "C180"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/07_Abbreviations#page_xiii"
    }
  }, [_vm._v("Abbreviations")])]), _vm._v(" "), _c('p', {
    staticClass: "C135"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/08_Acknowledgments#page_xvii"
    }
  }, [_vm._v("Acknowledgments")])]), _vm._v(" "), _c('p', {
    staticClass: "C180"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/09_Preface#page_xix"
    }
  }, [_vm._v("Preface")])]), _vm._v(" "), _c('p', {
    staticClass: "C180"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/10_1__Introduction#page_1"
    }
  }, [_vm._v("1. Introduction")])]), _vm._v(" "), _c('p', {
    staticClass: "C180"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/11_2__Conceptual_Framework#page_18"
    }
  }, [_vm._v("2. Conceptual Framework")])]), _vm._v(" "), _c('p', {
    staticClass: "C180"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/12_3__No_Haste__The_1996_National_D#page_53",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3. No Haste: The 1996 National Development Conference")])]), _vm._v(" "), _c('p', {
    staticClass: "C180"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/13_4__Active_Opening__Effective_Man#page_90",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4. Active Opening, Effective Management: The 2001 Economic Development Advisory Conference")])]), _vm._v(" "), _c('p', {
    staticClass: "C180"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/14_5__Active_Management__Effective#page_126",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5. Active Management, Effective Opening: The 2006 Conference on Sustaining Taiwan’s Economic Development")])]), _vm._v(" "), _c('p', {
    staticClass: "C180"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/15_6___Prosper_Again___The_2008_201#page_162",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6. “Prosper Again”: The 2008–2010 Campaign for the ECFA")])]), _vm._v(" "), _c('p', {
    staticClass: "C135"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/16_7__Conclusions#page_206",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7. Conclusions")])]), _vm._v(" "), _c('p', {
    staticClass: "C180"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/17_Appendix__Sources_Related_to_Pub#page_227",
      "id": "page_viii",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Appendix: Sources Related to Public Opinion Surveys and Polls on Taiwan")])]), _vm._v(" "), _c('p', {
    staticClass: "C180"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/18_Notes#page_229",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Notes")])]), _vm._v(" "), _c('p', {
    staticClass: "C180"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/19_References#page_241",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("References")])]), _vm._v(" "), _c('p', {
    staticClass: "C180"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/20_Index#page_259",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Index")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d06ac474","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/05_Contents.vue
// module id = 72
// module chunks = 0